import type { ReactNode } from 'react'

type BodyTextProps = {
  text: ReactNode
  className?: string
}
export default function BodyText({ text, className }: BodyTextProps): JSX.Element {
  return <p className={`text-[var(--text-landing-muted)] text-sm ${className ?? ''}`}>{text}</p>
}
